import httpAuth from "@/common/http/http-common";
import { EmployeeDto } from "@/types/user.type";

class EmployeeService {
  client = httpAuth("employee");

  async getOfficeEmployeesAsync(officeId: number): Promise<EmployeeDto[]> {
    const { data } = await this.client.get(`office/${officeId}/all`);

    return data;
  }

  async getPracticeEmployeesAsync(): Promise<EmployeeDto[]> {
    const { data } = await this.client.get("all");

    return data;
  }

  async downloadCertificateAsync(certificateId: number): Promise<Blob> {
    const { data } = await this.client.get(`certificate/${certificateId}/download`);

    return data;
  }

  async getBlockStatusAsync(practiceId: number, userId: number): Promise<boolean> {
    const { data } = await this.client.get(`practice/${practiceId}/user/${userId}/block`);

    return data;
  }

  async updateBlockStatusAsync(practiceId: number, userId: number): Promise<boolean> {
    const { data } = await this.client.put(`practice/${practiceId}/user/${userId}/block`);

    return data;
  }
}

export default new EmployeeService();